export const validateMedicareProviderNumber = (providerNumber: string): boolean => {
  /*
   * Validates an Australian Medicare provider number
   * Sourced from https://clearwater.com.au/code/provider/
   *
   * According to the guidelines, a provider number is comprised of:
   * Stem - 6 digits (digits 0-9)
   * Location Character - 1 digit or alphabetic character (digits 0-9 and characters except I, O, S and Z)
   * Check Character - 1 alphabetic character  (only A, B, F, H, J, K, L, T, W, X, Y)
   */
  const locTable = '0123456789ABCDEFGHJKLMNPQRTUVWXY'
  const checkTable = 'YXWTLKJHFBA'
  const weights = [3, 5, 8, 4, 2, 1]
  const regex = new RegExp(`^(\\d{5,6})([${locTable}])([${checkTable}])$`)

  // Convert to uppercase and remove non-alphanumeric characters
  const cleanedProviderNumber = providerNumber.toUpperCase().replace(/[^\dA-Z]/g, '')

  const matches = cleanedProviderNumber.match(regex)

  if (matches) {
    let stem = matches[1]

    // Accommodate dropping of leading 0
    if (stem.length === 5) {
      stem = '0' + stem
    }

    const location = matches[2]
    const checkDigit = matches[3][0]

    // IMPORTANT - letters I, O, S and Z are not included
    // Some documentation incorrectly removes the digit 1.
    const plv = locTable.indexOf(location)
    let sum = plv * 6

    weights.forEach((weight, position) => {
      sum += parseInt(stem[position]) * weight
    })

    if (checkDigit === checkTable[sum % 11]) {
      return true
    }
  }

  return false
}
